export const PREVIEW_MAX_BYTES = 50 * 1024 * 1024; // 50 MB

export const formatBytes = (bytes) => {
  if (!bytes) return "—";
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  if (bytes < 1024 * 1024 * 1024) return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
  return `${(bytes / (1024 * 1024 * 1024)).toFixed(2)} GB`;
};

export const getPreviewKind = (file) => {
  if (file?.is_previewable === false) return "unsupported";

  const ext = file?.extension?.toLowerCase()?.replace(/^\./, "");
  const category = file?.category?.toUpperCase();
  const contentType = file?.content_type?.toLowerCase() || "";

  if (["jpg", "jpeg", "png", "gif", "webp", "svg"].includes(ext)) return "image";
  if (ext === "pdf" || category === "PDF" || contentType === "application/pdf") return "pdf";
  if (ext === "md" || category === "MARKDOWN" || contentType.includes("markdown")) return "markdown";
  if (ext === "txt" || ext === "csv" || category === "TEXT" || contentType.startsWith("text/")) return "text";
  if (category === "IMAGE" || contentType.startsWith("image/")) return "image";

  return "unsupported";
};
